import React from 'react'
import * as R from 'remeda'

import {
  type DisplayRowItem,
  pathAssume,
  pathOrWith,
  QuestionOp,
} from '~/utils'

import { type DisplayRowId, getAnswerOptionRowId } from '../utils'

import { useCustomerAttributesArrayData } from './useCustomerAttributesArrayData'
import { useDisplayRowItems } from './useDisplayRowItems'
import { useNormalAnswersArrayData } from './useNormalAnswersArrayData'

export const useSequentialDisplayRowItems =
  (): DisplayRowItem<DisplayRowId>[] => {
    const answersArrayData = useNormalAnswersArrayData()
    const answersDisplayRowItems = useDisplayRowItems(
      'sequential',
      answersArrayData,
      {
        getLabel: pathOrWith('0.question', QuestionOp.toText, ''),
        getRowId: (answerData) =>
          getAnswerOptionRowId(answerData.question, answerData.answerOption),
        getSubLabel: pathAssume('answerOption.text'),
      },
    )

    const customerAttributesArrayData = useCustomerAttributesArrayData()
    const customerAttributeDisplayRowItems = useDisplayRowItems(
      'sequential',
      customerAttributesArrayData,
      {
        getLabel: pathAssume('0.customerAttributeGroup.name'),
        getRowId: pathAssume('customerAttribute.id'),
        getSubLabel: pathAssume('customerAttribute.name'),
      },
    )

    return React.useMemo(
      () => R.concat(answersDisplayRowItems, customerAttributeDisplayRowItems),
      [answersDisplayRowItems, customerAttributeDisplayRowItems],
    )
  }
